export const ACTION = {
    SURVEY_USER: 'SURVEY_USER',
};